import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import MultipleCargoSelect from '../inputs/MultipleCargoSelect';
import {
    normalizeParts,
    trimTrailingSeparators,
    SEPARATOR_PLUS,
} from '../../../models/common/EntityPart';
import { createSeparatorCargoPart } from '../../../models/CargoPart';

const CargoEditor = forwardRef((props, ref) => {
    const selectRef = useRef(null);

    const focus = () => {
        selectRef.current.focus();
    };

    const handleOnTab = () => props.api.tabToNextCell();

    const handleOnTabBack = () => props.api.tabToPreviousCell();

    const handleOnEnter = () => props.stopEditing();

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (selectRef.current.formattedValue.length > 0) {
                    var parts = normalizeParts(
                        selectRef.current.formattedValue,
                        createSeparatorCargoPart,
                        SEPARATOR_PLUS
                    );
                    return trimTrailingSeparators(parts);
                } else {
                    return null;
                }
            },

            isPopup() {
                return true;
            },

            afterGuiAttached() {
                focus();
            },
        };
    });

    return (
        <MultipleCargoSelect
            className="location-editor"
            ref={selectRef}
            context={props.context}
            field={props.column.colDef.field}
            initialChar={props.charPress}
            value={props.value}
            onTab={handleOnTab}
            onTabBack={handleOnTabBack}
            onEnter={handleOnEnter}
            seperatorCharacters={props.seperatorCharacters}
            blockedCharacters={props.blockedCharacters}
            defaultSeperatorCharacter={SEPARATOR_PLUS}
            groupId={props.data.groupId}
        />
    );
});

export default CargoEditor;
